import { twMerge } from 'tailwind-merge';
import {
  environmentBannerSpinnerStyles,
  EnvironmentBannerStyles,
  environmentBannerStyles,
} from './environment-banner.styles';
import { Typography } from '../../ui';
import { useSentryToolbar } from '@sentry/toolbar';

type Props = {
  environment: Exclude<
    EnvironmentBannerStyles['environment'],
    null | undefined
  >;
};

export function EnvironmentBanner(props: Props) {
  const { environment } = props;

  useSentryToolbar({
    enabled: props.environment === 'acceptance' || props.environment === 'test',
    initProps: {
      organizationSlug: 'maia',
      projectIdOrSlug: 'broker-studio',
    },
  });

  return (
    <div className={twMerge(environmentBannerStyles({ environment }))}>
      <span className="relative flex size-8">
        <span
          className={twMerge(
            environmentBannerSpinnerStyles({ environment }),
            'absolute inline-flex h-full w-full animate-ping rounded-full opacity-75',
          )}
        ></span>
        <span
          className={twMerge(
            environmentBannerSpinnerStyles({ environment }),
            'relative inline-flex size-8 rounded-full',
          )}
        ></span>
      </span>
      <Typography variant="body-s" weight="medium">
        {environment}
      </Typography>
    </div>
  );
}
